export default __webpack_public_path__ + "static/media/oola_header_logo.10ec9cde.png";